import React, { useEffect } from 'react'

export default function GalleryModal({ images, currentIndex, onClose, onPrev, onNext }) {
  const isOpen = Boolean(images && images.length > 0 && currentIndex >= 0)

  useEffect(() => {
    if (!isOpen) return

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose()
      if (e.key === 'ArrowLeft') onPrev()
      if (e.key === 'ArrowRight') onNext()
    }
    window.addEventListener('keydown', handleKeyDown)
    document.body.style.overflow = 'hidden'

    return () => {
      window.removeEventListener('keydown', handleKeyDown)
      document.body.style.overflow = ''
    }
  }, [isOpen, onClose, onPrev, onNext])

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/95 backdrop-blur-md">
      {/* Close button */}
      <button
        onClick={onClose}
        className="absolute top-6 right-6 z-50 flex h-12 w-12 items-center justify-center rounded-full border border-dark-700 bg-dark-900/80 text-white hover:bg-dark-800 transition-all hover:scale-105"
        aria-label="Luk galleri"
      >
        <i className="fa-solid fa-xmark text-lg" />
      </button>

      {/* Navigation buttons */}
      {images.length > 1 && (
        <>
          <button
            onClick={onPrev}
            className="absolute left-4 md:left-8 z-40 flex h-12 w-12 items-center justify-center rounded-full border border-dark-700 bg-dark-900/80 text-white hover:bg-dark-800 transition-all hover:scale-105"
            aria-label="Forrige billede"
          >
            <i className="fa-solid fa-chevron-left text-lg" />
          </button>
          <button
            onClick={onNext}
            className="absolute right-4 md:right-8 z-40 flex h-12 w-12 items-center justify-center rounded-full border border-dark-700 bg-dark-900/80 text-white hover:bg-dark-800 transition-all hover:scale-105"
            aria-label="Næste billede"
          >
            <i className="fa-solid fa-chevron-right text-lg" />
          </button>
        </>
      )}

      {/* Image container */}
      <div className="relative max-h-[85vh] max-w-[90vw] md:max-w-[80vw] flex flex-col items-center justify-center">
        <img
          src={images[currentIndex]}
          alt={`Galleri billede ${currentIndex + 1}`}
          className="max-h-[80vh] max-w-full rounded-lg object-contain shadow-2xl border border-dark-800 select-none"
        />
        
        {/* Counter */}
        <div className="mt-4 rounded-full bg-dark-900/60 border border-dark-800 px-4 py-1.5 text-xs text-slate-300 font-medium">
          {currentIndex + 1} / {images.length}
        </div>
      </div>
    </div>
  )
}
